import VendorAsClaimantForm from "./VendorAsClaimantForm";

export default VendorAsClaimantForm;
